import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { BorderBottom } from '@/components/uikit';
import { Product } from '@/types';
import { currencyHelper } from '@/utils/helper';
import { HeaderLabel } from './HeaderLabel';

interface Props {
  list: Product[];
  onBidding: boolean;
  earnings?: number;
  pharmacistNotes?: string;
}

export function MedicineList({
  list,
  onBidding,
  earnings,
  pharmacistNotes,
}: Props) {
  return (
    <Box mb="1rem" bgcolor="white" p={2} pb={0} flex={onBidding ? 1 : 0}>
      <HeaderLabel>Daftar Obat</HeaderLabel>
      <BorderBottom />
      <ul className="list medication-list">
        {list.map(_ => (
          <li className="items-center-flex" key={_.id}>
            <div className="medication-name">
              <p style={{ margin: 0, width: '50%', fontWeight: 600 }}>
                {_.name}
              </p>
              <p style={{ margin: 0, opacity: 0.6, fontSize: '12px' }}>
                {`Qty: ${_.qty} ${_.satuan ?? ''}${
                  _.direction ? `, ${_.direction}` : ''
                }`}
              </p>
              <p style={{ margin: 0, opacity: 0.6, fontSize: '12px' }}>
                Catatan dari Dokter: {_.doctor_notes || '-'}
              </p>
              {/* {_.is_required_self_pickup && (
                <p className="wajib-self-pickup-warning-text">
                  Obat ini harus diambil di apotik
                </p>
              )} */}
            </div>
            <div className="medication-price">
              <p>{currencyHelper(_.price)}</p>
            </div>
          </li>
        ))}
      </ul>

      {earnings && (
        <li className="medication-total-price" style={{ borderBottom: 0 }}>
          <b>Total pendapatan anda:</b>{' '}
          <b style={{ color: '#f69063' }}>{currencyHelper(earnings)}</b>
        </li>
      )}

      {pharmacistNotes && (
        <Box marginY="1rem" border="1px solid #ddd" borderRadius={12} p={2}>
          <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: 16 }}>
            Catatan dari apoteker:
          </Typography>
          <Typography style={{ fontSize: 14, whiteSpace: 'pre-line' }}>
            {pharmacistNotes}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
